import { Button, ButtonTheme } from '@cian/button-component';
import { OutsideClick } from '@cian/components';
import { mergeStyles } from '@cian/utils/lib/shared/style';
import { IAgentSchema, IOfferSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import * as React from 'react';

import { getCustomUrl } from '../../../utils/tracking';
import { ComplaintContainer } from '../../complaint/container';
import { trackClick } from './tracking';
import { EFeedbackComplaint } from '../../../store/complaint/feedback_complaint';

import * as styles from './index.css';

export interface IComplaintButtonProps {
  agent: IAgentSchema | null;
  className?: string;
  offer: IOfferSchema;
  complaintPopupOpen: boolean;

  complaintFeedbackFormStatus(status: EFeedbackComplaint): void;
  togglePopup(value: boolean): void;
}

export class ComplaintButton extends React.PureComponent<IComplaintButtonProps> {
  public render() {
    const { className, complaintPopupOpen } = this.props;

    return (
      <span {...mergeStyles([styles['container'], className])}>
        <Button
          className={styles['button']}
          onClick={this.handleClickOnButton}
          theme={ButtonTheme.Ghost}
          title="Пожаловаться"
        >
          Пожаловаться
        </Button>
        {complaintPopupOpen && (
          <OutsideClick onOutsideClick={this.handleOutsideClick}>
            <div className={styles['tooltip']}>
              <ComplaintContainer handleOutsideClick={this.handleOutsideClick} />
            </div>
          </OutsideClick>
        )}
      </span>
    );
  }

  private handleClickOnButton = () => {
    trackClick(getCustomUrl(this.props.offer, this.props.agent));
    this.props.togglePopup(!this.props.complaintPopupOpen);
  };

  private handleOutsideClick = () => {
    this.props.togglePopup(false);
    this.props.complaintFeedbackFormStatus(EFeedbackComplaint.default);
  };
}
